import ErrorPage from './error'
import DashboardPage from './dashboard'
import DuplicatePage from './dashboard/duplicate'

export {
    ErrorPage,
    DashboardPage,
    DuplicatePage
}